import * as S from './SummarySegment.styles';

interface SummarySegmentProps {
  children?: React.ReactNode;
}

const SummarySegment = ({ children }: SummarySegmentProps) => {
  return (
    <S.Root data-test-id="payment-summary" elevation={2}>
      {children}
    </S.Root>
  );
};

export default SummarySegment;
